import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SignUpComponent } from './components/sign-up.component';

const routes: Routes = [
  {
    path: 'sign-up',
    component: SignUpComponent,
  },
  {
    path: 'sign-up-error',
    component: SignUpComponent,
  },
  {
    path: 'set-pathfinder-credentials',
    component: SignUpComponent,
  },
  {
    path: 'set-pathfinder-credentials-error',
    component: SignUpComponent,
  },
  {
    path: 'set-pathfinder-credentials-success',
    component: SignUpComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SignUpRoutingModule {}
